<div class="row mt-2" *ngIf="cards && cards.length > 0">
  <div class="col-sm-6">
    <label *scText="rendering.fields.name"></label>
    <mat-form-field
      class="d-block ab-select form-control-custom"
      [floatLabel]="'never'"
      hideRequiredMarker
    >
      <mat-select
        [(ngModel)]="selectedCard"
        (selectionChange)="changeAccount()"
        [placeholder]="placeholder"
        [disabled]="cards.length === 1"
      >
        <mat-option *ngFor="let card of cards" [value]="card">
          {{ card.name }} - {{ card.suffix }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <div class="text-nowrap">
        <label class="login" *scText="rendering.fields.balance"></label>
      </div>
      <h3 class="amount" [ngClass]="{ 'amount-flipin': animateAmount }">
        {{ selectedCard?.balance.amount | number }}
        {{ selectedCard?.balance.currencyCode }}
      </h3>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <div class="text-nowrap">
        <label class="login" *scText="rendering.fields.availableCredit"></label>
      </div>
      <h3 class="amount" [ngClass]="{ 'amount-flipin': animateAmount }">
        {{ selectedCard?.availableCredit.amount | number }}
        {{ selectedCard?.availableCredit.currencyCode }}
      </h3>
    </div>
  </div>
</div>
